import { Badge } from '../ui/Badge'
import type { PostStatus } from '../../types'

export function PostStatusBadge({ status }: { status: PostStatus }) {
  return (
    <Badge variant={status === 'published' ? 'success' : 'warning'} dot>
      {status === 'published' ? 'Published' : 'Draft'}
    </Badge>
  )
}
